<!-- 个人信息 -->
<template>
  <div>
    <el-form ref="form" :model="form" class="flex flex-row" :rules="rules">
      <div class="w-[50%]">
        <el-form-item label="用户名" prop="name">
          <el-input v-model="form.name" placeholder="请输入用户名" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="移动电话" prop="phone">
          <el-input v-model="form.phone" placeholder="请输入移动电话" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="电子邮箱" prop="email">
          <el-input v-model="form.email" placeholder="请输入电子邮箱"></el-input>
        </el-form-item>
        <el-form-item class="mt-[40px]">
          <el-button type="primary" @click="submitForm">保存</el-button>
        </el-form-item>
      </div>
      <div class="w-[50%] pl-[50px]">
        <p class="text-[14px] text-[#606266]">头像</p>
        <div class="inline-block relative">
          <el-upload
            class="avatar-uploader"
            ref="avatarUpload"
            action="#"
            :show-file-list="false"
            :on-change="handleAvatarChange"
            :auto-upload="false"
          >
            <img v-if="form.thumb" :src="form.thumb" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
          <el-button
            icon="el-icon-edit"
            size="medium"
            class="absolute bottom-[5px] right-0 !px-[8px] !py-[6px]"
            @click="handleAvatarClick"
            >修改</el-button
          >
        </div>
      </div>
    </el-form>
    <!-- 头像裁剪弹窗 -->
    <AvatarCropper v-model="dialogVisible" @update-visible="updateDialogVisible" :cropperUrl="cropperUrl" />
  </div>
</template>

<script>
import AvatarCropper from './AvatarCropper.vue';
import { mapGetters } from 'vuex';
import { EventBus } from '@/utils/eventbus';
import { uploadImg } from '@/api/user-center';

export default {
  name: 'AccountInfo',
  components: {
    AvatarCropper,
  },
  data() {
    return {
      dialogVisible: false,
      cropperUrl: null,
      fileType: ['jpg', 'gif', 'jpeg', 'png', 'bmp'],
      fileSize: 5,
      form: {
        name: '',
        thumb: '',
        email: '',
        phone: '',
      },
      rules: {
        name: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        phone: [
          { required: true, message: '请输入移动电话', trigger: 'change' },
          {
            pattern: /^(?:(?:\+|00)86)?1\d{10}$/,
            message: '请输入正确的手机号码',
            trigger: 'change',
          },
        ],
        email: [
          { required: true, message: '请输入邮箱', trigger: 'change' },
          {
            pattern:
              /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
            message: '请输入正确的邮箱',
            trigger: 'change',
          },
        ],
      },
    };
  },
  computed: {
    ...mapGetters(['name', 'avatar', 'email', 'phone']),
  },
  mounted() {
    this.getData();

    // 触发 - 上传处理后的图片
    EventBus.$on('upload:cropper', (file) => {
      this.uploadAvatar(file);
    });
  },
  methods: {
    // 获取初始个人信息
    getData() {
      this.form.name = this.name;
      this.form.thumb = this.avatar;
      this.form.email = this.email;
      this.form.phone = this.phone;
    },
    // 关闭弹窗
    updateDialogVisible(e) {
      this.dialogVisible = e;
    },
    // 选取图片（按钮）
    handleAvatarClick() {
      this.$refs.avatarUpload.$children[0].$refs.input.click();
    },
    // 选取图片
    handleAvatarChange(file) {
      if (!file.type) {
        file.type = file.raw.type;
      }

      // 校验文件类型
      if (this.fileType && file && this.fileType.indexOf(file.type.split('/')[1]) === -1) {
        this.$message.warning(`文件格式不正确！请上传 ${this.fileType.join(', ')} 格式的文件`);
        this.$refs.avatarUpload.handleRemove(file);
        return;
      }
      // 校验文件大小
      if (this.fileSize && file && file.size / 1024 / 1024 > this.fileSize) {
        this.$message.warning(`文件大小超过限制！请上传不超过 ${this.fileSize} MB 的文件`);
        this.$refs.avatarUpload.handleRemove(file);
        return;
      }

      this.cropperUrl = URL.createObjectURL(file.raw);
      this.dialogVisible = true;
    },
    // 上传处理后的图片
    uploadAvatar(file) {
      uploadImg(file)
        .then((res) => {
          this.$message.success('上传成功');
          this.form.thumb = res.data;
        })
        .catch((err) => {});
    },
    // 保存个人信息
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$store
            .dispatch('updateInfo', this.form)
            .then(() => {
              this.$message.success('保存成功');
            })
            .catch((err) => {
              this.$message.error(err.msg);
            });
        } else {
          this.$message({
            message: '资料填写不完整',
            type: 'error',
          });
          return false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.status {
  &:after {
    content: '';
    position: absolute;
    background: #eff1f1;
    height: 1px;
    width: 60px;
    left: 0;
    top: 50%;
    transform: translateX(-100%);
  }
  &:before {
    content: '';
    position: absolute;
    background: #eff1f1;
    height: 1px;
    width: 60px;
    right: 0;
    top: 50%;
    transform: translateX(100%);
  }
}

// 覆盖表单样式
.el-form-item {
  margin-bottom: 5px !important;
}

.avatar-uploader {
  margin-top: 20px;
}
::v-deep .avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 50%;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
::v-deep .avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 140px;
  height: 140px;
  line-height: 140px;
  text-align: center;
}
.avatar {
  width: 160px;
  height: 160px;
  display: block;
}
.avatar-pen {
  position: absolute;
  bottom: 0;
}
</style>
